import { render } from "./manager_all_urgent_packets.vue?vue&type=template&id=b33c2d00"
import script from "./manager_all_urgent_packets.vue?vue&type=script&lang=js"
export * from "./manager_all_urgent_packets.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\shiv_mfg_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__